"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.InsertItemPlacer = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _ProjectRow = require("./ProjectRow");
var _Rule = require("./Rule");
var _controllers = require("../controllers");
var InsertItemPlacer = /*#__PURE__*/function () {
  function InsertItemPlacer() {
    (0, _classCallCheck2["default"])(this, InsertItemPlacer);
  }
  (0, _createClass2["default"])(InsertItemPlacer, null, [{
    key: "addRowInPlacer",
    value: function addRowInPlacer(data, project, iCad, forcedResolver) {
      return new _promise["default"](function (resolve, reject) {
        var rowToInsertPlacer = data.row;
        var idSlotInRow = data.slotID;
        var slotType = data.slotType;
        var rule = new _Rule.Rule(data.reg.res.rule);
        var historyRow = project.getLastHistoryEntry();
        project.addNewRow(_ProjectRow.rowTypes.BOX);
        var newRow = project.getCurrentRow();
        newRow.initRowFromRule(historyRow.catalog, historyRow.currentModel.header, rule);
        var inserted = project.setClassicPlacerChild(rowToInsertPlacer.uniqueid, newRow.uniqueid, idSlotInRow, slotType);
        if (!inserted) {
          console.error("Slot occupied");
        }
        InsertItemPlacer.evalPlacer(project, newRow, forcedResolver, iCad, resolve, true);
      });
    }
  }, {
    key: "moveRowPlacer",
    value: function moveRowPlacer(data, project, iCad, forcedResolver) {
      return new _promise["default"](function (resolve, reject) {
        var rowToInsertPlacer = data.row;
        var idSlotInRow = data.slotID;
        var slotType = data.slotType;
        var rowMoving = data.rowMoving;
        var inserted = project.moveClassicPlacerChild(rowToInsertPlacer.uniqueid, rowMoving.uniqueid, idSlotInRow, slotType);
        if (!inserted) {
          console.log("Slot occupied");
        }
        InsertItemPlacer.evalPlacer(project, rowMoving, forcedResolver, iCad, resolve, false);
      });
    }
  }, {
    key: "evalPlacer",
    value: function evalPlacer(project, newRow, forcedResolver, iCad, resolve, isInserting) {
      var encodePrj = project.getJson();
      var rows = encodePrj.rows;
      var afterEvalPlacer = function afterEvalPlacer(json) {
        if (isInserting) {
          forcedResolver.resolve(newRow.rule, newRow.catalog).then(function (newRule) {
            newRow.setRule(newRule);
            iCad.insertBoxPlacer(project);
            resolve(json);
          });
        } else {
          iCad.moveBoxPlacer(project, newRow);
          resolve(json);
        }
      };
      _controllers.RowEval.evalRowPlacer(newRow, project).then(afterEvalPlacer)["catch"](function (err) {
        console.error(err);
      });
    }
  }]);
  return InsertItemPlacer;
}();
exports.InsertItemPlacer = InsertItemPlacer;
//# sourceMappingURL=InsertItemPlacer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/InsertItemPlacer.js
// module id = 1262
// module chunks = 142